import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '@/app/hooks'
import { checkout } from '@/features/checkout/checkout-data-slice'
import { useAppSelector } from '@/app/hooks'

interface UseCheckoutParams {
  hotelId: string
}

/**
 * チェックアウト処理用のカスタムフック
 * チェックアウト処理の実行とナビゲーションを管理
 */
export const useCheckout = ({ hotelId }: UseCheckoutParams) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const checkoutReservationIds = useAppSelector(state => state.checkout.checkoutReservation.checkoutReservationIds)
  const loadingCheckout = useAppSelector(state => state.checkout.checkoutData.loading)
  /**
   * チェックアウト処理を実行
   * 全ての予約に対してチェックアウトを実行し、完了後にサンクスページに遷移
   */
  const handleCheckout = useCallback(async () => {
    for (const reservationId of checkoutReservationIds) {
      await dispatch(
        checkout({
          hotelId: hotelId,
          checkinId: '',
          reservationId: reservationId,
          withReview: true,
        }),
      )
    }
  }, [hotelId, checkoutReservationIds, dispatch, navigate])

  return {
    handleCheckout,
    loadingCheckout,
  }
}
